import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isEmpty from 'lodash/isEmpty'

import {
  loadSkuSimulation,
  clearSimulationError,
  clearLogisticsInfoCache,
  simulationRefreshed,
} from '@/checkout-instore-legacy/cart/simulation/actions'

import {
  isSimulationLoadingSelector,
  simulationErrorSelector,
  shouldSimulationRefreshSelector,
} from '@/checkout-instore-legacy/cart/simulation/selectors'

import BuyComponent from './BuyComponent'

const mapStateToProps = (state) => ({
  isSimulationLoading: isSimulationLoadingSelector(state),
  hasSimulationError: !isEmpty(simulationErrorSelector(state)),
  shouldSimulationRefresh: shouldSimulationRefreshSelector(state),
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadSkuSimulation,
      clearSimulationError,
      clearLogisticsInfoCache,
      simulationRefreshed,
    },
    dispatch
  )

// Passed props by parent components will take precedence
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
  ...dispatchProps,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(BuyComponent)
